export default "__VITE_ASSET__53829cb9__"